
import { defineComponent, reactive, ref } from 'vue'
import { useBillingTemplateModule, AddBasicBillingTemplate, DeliveryPolicyType } from '@/modules/billing-templates'
import BillingTemplatesBasicBillingTemplateFormPart from '@/components/billing-templates/form-parts/basic-billing-template.vue'
import BillingTemplatesEmailDeliveryPolicyFormPart from '@/components/billing-templates/form-parts/email-delivery-policy.vue'
import BillingTemplatesElectronicDeliveryPolicyFormPart from '@/components/billing-templates/form-parts/electronic-delivery-policy.vue'
import BillingTemplatesFormFieldDeliveryPolicyType from '@/components/billing-templates/form-fields/delivery-policy-type.vue'
import { ElectronicDeliveryPolicy, EmailDeliveryPolicy } from '@/modules/billing-templates/types'
import { useRoute, useRouter } from 'vue-router'
import QForm from 'quasar/src/components/form/QForm.js';
import { useFormModule } from '@/modules/_shared/forms'
import { OrganizationsRouteNames } from '@/router/routes-names'

export default defineComponent({
    name: 'billing-templates-new-form',
    components: {
        BillingTemplatesBasicBillingTemplateFormPart,
        BillingTemplatesEmailDeliveryPolicyFormPart,
        BillingTemplatesElectronicDeliveryPolicyFormPart,
        BillingTemplatesFormFieldDeliveryPolicyType
    },
    props: {
        organizationId: {
            type: String,
            required: true
        }
    },
    setup (props) {
        const router = useRouter()
        const route = useRoute()
        const { submitForm, createOnSuccess } = useFormModule()
        const form = ref<QForm>()
        const { addMailBillingTemplate, addEmailBillingTemplate, addElectronicBillingTemplate } = useBillingTemplateModule()

        const basicBillingTemplateModel = reactive<AddBasicBillingTemplate>({
            templateName: '',
            organizationName: '',
            businessId: '',
            street: '',
            city: '',
            zip: '',
            countryCode: '',
            contactPersonEmail: '',
            contactPersonName: '',
            vatId: '',
            customerNumber: '',
            reference: '',
            organizationId: props.organizationId,
            paymentTerms: null,
            invoiceDescription: null
        })

        const deliveryPolicyTypeModel = ref('')

        const emailDeliveryPolicyModel = reactive<EmailDeliveryPolicy>({
            email: ''
        })

        const electronicInvoiceDeliveryPolicyModel = reactive<ElectronicDeliveryPolicy>({
            electronicAddress: '',
            electronicOperatorId: '',
            electronicOperatorCode: ''
        })

        const sendRequest = async () => {
            switch (deliveryPolicyTypeModel.value) {
            case DeliveryPolicyType.Mail:
                await addMailBillingTemplate(props.organizationId, basicBillingTemplateModel)
                break
            case DeliveryPolicyType.Email:
                await addEmailBillingTemplate(props.organizationId, { ...basicBillingTemplateModel, ...emailDeliveryPolicyModel })
                break
            case DeliveryPolicyType.Electronic:
                await addElectronicBillingTemplate(props.organizationId, { ...basicBillingTemplateModel, ...electronicInvoiceDeliveryPolicyModel })
            }
        }

        const moveToList = () => router.push({ name: OrganizationsRouteNames.SHOW, params: { organizationId: props.organizationId }, query: { page: route.query.page } })

        function moveToOrganizationShowPage () {
            const destination = {
                name: OrganizationsRouteNames.SHOW,
                params: { organizationId: props.organizationId },
                query: { page: route.query.page }
            }
            router.push(destination)
        }

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess('New billing template created')
        ).then(moveToList)

        return {
            onSubmit,
            basicBillingTemplateModel,
            electronicInvoiceDeliveryPolicyModel,
            emailDeliveryPolicyModel,
            deliveryPolicyTypeModel,
            form,
            OrganizationsRouteNames,
            DeliveryPolicyType,
            moveToOrganizationShowPage
        }
    }
})
